/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useTranslate } from "../../hooks/useTranslate";

const T = ({ children, ...params }) => {
  const { _t } = useTranslate();
  const translationParams = Object.keys(params).length ? { ...params } : undefined;

  return _t(children, translationParams);
};

export default T;
